import { useMemo } from "react"
import { useTypedSelector } from "store"

const useShopUrl = (modelId: number) => {
  const { selectedColorCode } = useTypedSelector((state) => state.color)
  const { selectedDetailingCode } = useTypedSelector((state) => state.detailing)
  const { selectedUpholsteryCode } = useTypedSelector(
    (state) => state.upholstery
  )
  const { selectedAccessoriesCodes } = useTypedSelector(
    (state) => state.accessories
  )

  const { model } = useTypedSelector((state) => state.wizard)

  const getShopUrl = useMemo(() => {
    if (!model || model.id !== modelId) return `/shop/${modelId}`
    const url = new URLSearchParams()
    if (selectedColorCode) url.append("color", selectedColorCode)
    if (selectedDetailingCode) url.append("detailing", selectedDetailingCode)
    if (selectedUpholsteryCode) url.append("upholstery", selectedUpholsteryCode)
    if (selectedAccessoriesCodes && Array.isArray(selectedAccessoriesCodes)) {
      selectedAccessoriesCodes.forEach((code) =>
        url.append("accessories", code)
      )
    }

    return `/shop/${modelId}?${url.toString()}` || `/shop/${modelId}`
  }, [
    model,
    modelId,
    selectedColorCode,
    selectedDetailingCode,
    selectedUpholsteryCode,
    selectedAccessoriesCodes,
  ])

  return getShopUrl
}

export default useShopUrl
